import { render } from "./win.vue?vue&type=template&id=26af3fe0&scoped=true"
import script from "./win.vue?vue&type=script&lang=js"
export * from "./win.vue?vue&type=script&lang=js"

import "./win.vue?vue&type=style&index=0&id=26af3fe0&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26af3fe0"]])

export default __exports__